// import React, { useState, useRef, useEffect } from "react";
// import {
//   Editor,
//   EditorState,
//   ContentState,
//   Modifier,
//   SelectionState,
//   RichUtils,
// } from "draft-js";
// import "draft-js/dist/Draft.css";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   IconButton,
//   TextField,
//   Menu,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Popover,
//   Box,
//   Typography,
//   Chip,
//   Divider,
//   Stack,
//   useTheme,
//   alpha,
//   InputBase,
//   Paper,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { useHistory } from "react-router-dom";
// import RedoIcon from "@mui/icons-material/Redo";
// import UndoIcon from "@mui/icons-material/Undo";
// import FormatSizeIcon from "@mui/icons-material/FormatSize";
// import FormatItalicIcon from "@mui/icons-material/FormatItalic";
// import FormatBoldIcon from "@mui/icons-material/FormatBold";
// import FeedbackIcon from "@mui/icons-material/Feedback";
// import {Delete} from "@mui/icons-material";
// import DownloadIcon from "@mui/icons-material/Download";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import AddIcon from "@mui/icons-material/Add";
// import FolderOpenIcon from "@mui/icons-material/FolderOpen";
// import ImportExportIcon from "@mui/icons-material/ImportExport";
// import EditIcon from "@mui/icons-material/Edit";
// import SaveIcon from "@mui/icons-material/Save";
// import PrintIcon from "@mui/icons-material/Print";
// import CloseIcon from "@mui/icons-material/Close";
// import ContentCutIcon from "@mui/icons-material/ContentCut";
// import ContentPasteIcon from "@mui/icons-material/ContentPaste";
// import SelectAllIcon from "@mui/icons-material/SelectAll";
// import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
// import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
// import SuperscriptIcon from "@mui/icons-material/Superscript";
// import SubscriptIcon from "@mui/icons-material/Subscript";
// import CodeIcon from "@mui/icons-material/Code";
// import FormatClearIcon from "@mui/icons-material/FormatClear";
// import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
// import NewReleasesIcon from "@mui/icons-material/NewReleases";
// import CloudDoneIcon from "@mui/icons-material/CloudDone";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CircularProgress from "@mui/material/CircularProgress";
// import { toast } from "react-toastify";
// import { useDispatch, useSelector } from "react-redux";
// import { deleteDocuments } from "../../services/document";
// import { addUserLogs } from "../../services/userLogServices";
// import { DownloadOptionModal } from "../MyDocumentsCardsModal";
// import { useCheckFeatureAccess } from "../CheckFeature";
// import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import { openLeftNavbar } from "../../redux/handleSideNavBarAndModel/handleStatus.action";
// import { resetTemplateName } from "../../redux/coauthor/coauthor.action";
// import { withStyles } from "@material-ui/core/styles";
// import Tooltip from "@material-ui/core/Tooltip";

// // ==================== STYLED COMPONENTS ====================

// const LightTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: "blue",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }))(Tooltip);

// const StyledAppBar = styled(AppBar)(({ theme }) => ({
//   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   boxShadow: "0 4px 20px 0 rgba(0,0,0,0.12)",
// }));

// const StyledToolbar = styled(Toolbar)(({ theme }) => ({
//   minHeight: "30px",
//   paddingLeft: theme.spacing(2),
//   paddingRight: theme.spacing(2),
//   [theme.breakpoints.down("sm")]: {
//     minHeight: "30px",
//     paddingLeft: theme.spacing(1),
//     paddingRight: theme.spacing(1),
//   },
// }));

// const TitleInput = styled(InputBase)(({ theme }) => ({
//   color: "white",
//   fontSize: "1.25rem",
//   fontWeight: 500,
//   minWidth: "170px !important",
//   maxWidth: "170px",
//   backgroundColor: alpha(theme.palette.common.white, 0.12),
//   borderRadius: theme.shape.borderRadius,
//   "& .MuiInputBase-input": {
//     padding: theme.spacing(1, 2),
//     transition: theme.transitions.create(["background-color"]),
//     "&:hover": {
//       backgroundColor: "transparent",
//     },
//     "&:focus": {
//       backgroundColor: "transparent",
//     },
//   },
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.common.white, 0.18),
//   },
//   "&.Mui-focused": {
//     backgroundColor: alpha(theme.palette.common.white, 0.2),
//   },
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "1rem",
//   },
// }));

// const MenuButton = styled(Button)(({ theme }) => ({
//   color: "white",
//   textTransform: "none",
//   fontSize: "0.95rem",
//   fontWeight: 500,
//   padding: theme.spacing(1, 2),
//   borderRadius: theme.shape.borderRadius,
//   transition: theme.transitions.create(["background-color"]),
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.common.white, 0.1),
//   },
//   "&:disabled": {
//     color: alpha(theme.palette.common.white, 0.4),
//   },
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "0.85rem",
//     padding: theme.spacing(0.5, 1),
//   },
// }));

// const StatusChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: alpha(theme.palette.common.white, 0.12),
//   color: "white",
//   fontWeight: 500,
//   borderRadius: theme.shape.borderRadius,
//   "& .MuiChip-icon": {
//     color: "#4ade80",
//   },
// }));

// const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
//   padding: theme.spacing(1.5, 2),
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.primary.main, 0.08),
//   },
//   "& .MuiSvgIcon-root": {
//     marginRight: theme.spacing(1.5),
//     color: theme.palette.primary.main,
//   },
// }));

// // ==================== MAIN COMPONENT ====================

// const CoAuthorTopMenubar = (props) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const { clickState } = useSelector((state) => state.handleClick);
//   const currentNavItem = useSelector(
//     (state) => state.manageCoauthorNavReducer.currentCoauthorNavItem
//   );
//   const { isFullSize } = useSelector((state) => state.manageFullSizeEditor);

//   const [fileMenuAnchor, setFileMenuAnchor] = useState(null);
//   const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);
//   const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
//   const [projectName, setProjectName] = useState("");
//   const [Finalprojectname, setFinalprojectname] = useState(props.docName);
//   const [isEditing, setEditing] = useState(false);
//   const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

//   const accessToTitle = useCheckFeatureAccess(currentNavItem, "addTitle");
//   const accessToFile = useCheckFeatureAccess(currentNavItem, "file");
//   const history = useHistory();

//   useEffect(() => {
//     if (props.docName === "") {
//       if (clickState === "blog") {
//         if (
//           props.editorState?.trim()?.split(/\s+/).length > 2 &&
//           Finalprojectname === "Untitled Blog"
//         ) {
//           let proName = props.editorState
//             ?.trim()
//             ?.split(/\s+/)
//             ?.slice(0, 2)
//             ?.join(" ");
//           setFinalprojectname(proName);
//           props.setDocName(proName);
//         }
//       } else {
//         if (
//           props.editorState?.trim()?.split(/\s+/).length > 2 &&
//           Finalprojectname === ""
//         ) {
//           let proName = props.editorState
//             ?.trim()
//             ?.split(/\s+/)
//             ?.slice(0, 2)
//             ?.join(" ");
//           setFinalprojectname(proName);
//           props.setDocName(proName);
//         }
//       }
//     } else if (props.editorState === "" || props.editorState === undefined) {
//       if (clickState === "blog") {
//         setFinalprojectname("Untitled Blog");
//       } else {
//         setFinalprojectname(props.docName);
//       }
//     } else {
//       let proName = props.editorState?.split(/\s+/).slice(0, 2).join(" ");
//       setFinalprojectname(proName);
//     }
//   }, [props.editorState]);

//   useEffect(() => {
//     props.setSharedState(Finalprojectname);
//   }, [Finalprojectname]);

//   const handleEditClick = () => {
//     if (accessToTitle) {
//       setEditing(true);
//     }
//   };

//   const handleSaveClick = () => {
//     if (clickState === "blog") {
//       setFinalprojectname(Finalprojectname || "Untitled Blog");
//       setEditing(false);
//       props.setDocName(Finalprojectname || "Untitled Blog");
//     } else {
//       setFinalprojectname(Finalprojectname || "Untitled Document");
//       setEditing(false);
//       props.setDocName(Finalprojectname || "Untitled Document");
//     }
//   };

//   const handleChange = (e) => {
//     setFinalprojectname(e.target.value);
//     // props.setDocName(e.target.value);
//   };

//   const handleMenuClick = (event, menuType) => {
//     switch (menuType) {
//       case "file":
//         setFileMenuAnchor(event.currentTarget);
//         break;
//       case "help":
//         setHelpMenuAnchor(event.currentTarget);
//         break;
//       default:
//         break;
//     }
//   };

//   const handleCloseMenu = () => {
//     setFileMenuAnchor(null);
//     setHelpMenuAnchor(null);
//   };

//   const handleCloseProject = () => {
//     history.goBack();
//   };

//   const handleOpenProject = () => {
//     history.goBack();
//   };

//   const handleDelete = () => {
//     setDeleteConfirmationOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     const res = await deleteDocuments(props.docId || props.newDocId);
//     if (res.status === 200) {
//       toast.success("Document deleted!");
//       const data = {
//         userId: sessionStorage.getItem("userId"),
//         organizationId: sessionStorage.getItem("organizationId"),
//         actionType: "deleteDoc",
//       };
//       const addLogs = await addUserLogs(data);
//       if (addLogs.status !== 200) {
//         toast.error(addLogs.message);
//       }
//     } else {
//       toast.error("Oops..Something went wrong!!");
//     }
//     setDeleteConfirmationOpen(false);
//     history.goBack();
//   };

//   const handleCancelDelete = () => {
//     setDeleteConfirmationOpen(false);
//   };

//   const handlePrint = () => {
//     if (props.editor.current && props.editor.current.editor) {
//       const editorContent = props.editor.current.editor.innerHTML;
//       const printWindow = window.open("", "_blank", "width=800,height=600");
//       printWindow.document.open();
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Print Document</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               img { max-width: 100%; height: auto; }
//               p { margin: 10px 0; }
//             </style>
//           </head>
//           <body>${editorContent}</body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.onload = () => {
//         printWindow.print();
//         printWindow.close();
//       };
//     }
//     handleCloseMenu();
//   };

//   const handleExport = () => {
//     setIsDownloadModalOpen(true);
//     handleCloseMenu();
//   };

//   const closeDownloadModal = () => {
//     setIsDownloadModalOpen(false);
//   };

//   const handleNewProject = () => {
//     handleCloseMenu();
//     window.location.reload(true);
//   };

//   const convertTextToHtml = (text) => {
//     const paragraphs = text.split("\n");
//     const htmlContent = paragraphs.map((paragraph) => {
//       const paragraphWithBreaks = paragraph.replace(/\n{2,}/g, "<br><br>");
//       return `<p>${paragraphWithBreaks}</p>`;
//     });
//     return htmlContent.join("");
//   };

//   const handleImport = () => {
//     const fileInput = document.createElement("input");
//     fileInput.type = "file";
//     fileInput.style.display = "none";

//     fileInput.addEventListener("change", (event) => {
//       const fileList = event.target.files;
//       if (fileList.length > 0) {
//         const file = fileList[0];
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           const fileContent = e.target.result;
//           const text = fileContent.toString();
//           let contentToSend;

//           if (file.name.endsWith(".txt")) {
//             const htmlContent = convertTextToHtml(text);
//             contentToSend = `<br>${htmlContent}`;
//             props.setEditorContentUpload(
//               props.editorHtmlContent + contentToSend
//             );
//           } else if (file.name.endsWith(".docx")) {
//             const bodyContentRegex = /<body[^>]*>([\s\S]*?)<\/body>/i;
//             const match = bodyContentRegex.exec(text);
//             contentToSend = match ? `<br>${match[1]}` : "";
//             props.setEditorContentUpload(
//               props.editorHtmlContent + contentToSend
//             );
//           } else {
//             toast.warning("Please upload .txt or .docx file");
//             return;
//           }
//         };
//         reader.readAsText(file);
//       }
//     });

//     document.body.appendChild(fileInput);
//     fileInput.click();
//     document.body.removeChild(fileInput);
//     handleCloseMenu();
//   };

//   const iconMapping = {
//     "New Project": <AddIcon />,
//     "Open Project": <FolderOpenIcon />,
//     "Import File": <ImportExportIcon />,
//     Delete: <Delete />,
//     Export: <SaveIcon />,
//     Print: <PrintIcon />,
//     "Close Project": <CloseIcon />,
//     Tutorials: <EmojiObjectsIcon />,
//     FAQs: <HelpOutlineIcon />,
//     Feedback: <FeedbackIcon />,
//     "What's New": <NewReleasesIcon />,
//   };

//   const actionHandlers = {
//     "Close Project": handleCloseProject,
//     Print: handlePrint,
//     Export: handleExport,
//     Delete: handleDelete,
//     "New Project": handleNewProject,
//     "Open Project": handleOpenProject,
//     "Import File": handleImport,
//   };

//   const renderMenuOptions = (options) => {
//     return options.map((option) => (
//       <StyledMenuItem key={option} onClick={() => actionHandlers[option]?.()}>
//         {iconMapping[option]}
//         <Typography variant="body2">{option}</Typography>
//       </StyledMenuItem>
//     ));
//   };

//   const handleBackButton = () => {
//     if (props.selectedEditOption || props.sharedDocument) {
//       if (props.isCoAuthor) {
//         history.push("/coauthor");
//       } else {
//         history.goBack();
//       }
//     }
//     dispatch(resetTemplateName(""));
//     dispatch(openLeftNavbar());
//     // handleMenuItemClick("Editor View");
//   };

//   return (
//     <>
//       <StyledAppBar position="static" elevation={0}>
//         {/* Main Toolbar */}
//         <StyledToolbar
//           style={{
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           }}
//         >
//           {!props.isGrammarCheck && !props.trial && !props.mobileView && (
//             <LightTooltip title="Back">
//               <KeyboardBackspaceIcon
//                 onClick={handleBackButton}
//                 color="white"
//                 style={{ cursor: "pointer" }}
//               />
//             </LightTooltip>
//           )}
//           {/* linear-gradient(135deg, rgba(31, 20, 128, 1), rgb(12, 127, 243)) */}

//           {/* Left Section - Title */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               flex: 1,
//               padding: "8px !important",
//             }}
//           >
//             {isEditing ? (
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                 }}
//               >
//                 <TitleInput
//                   value={props.Finalprojectname}
//                   onChange={handleChange}
//                   autoFocus
//                   placeholder="Document title"
//                 />

//                 <IconButton
//                   size="small"
//                   onClick={handleSaveClick}
//                   sx={{
//                     color: "white",
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     "&:hover": {
//                       bgcolor: alpha(theme.palette.common.white, 0.2),
//                     },
//                   }}
//                 >
//                   <CheckCircleIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             ) : (
//               <Box
//                 onClick={handleEditClick}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   cursor: accessToTitle ? "pointer" : "default",
//                   gap: 1,
//                   backgroundColor: alpha(theme.palette.common.white, 0.12),
//                   px: 1,
//                   py: 1,
//                   borderRadius: 1,
//                   transition: "background-color 0.2s",
//                   "&:hover": accessToTitle
//                     ? {
//                         backgroundColor: alpha(
//                           theme.palette.common.white,
//                           0.18
//                         ),
//                         "& .edit-icon": { opacity: 1 },
//                       }
//                     : {},
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     color: "white",
//                     fontWeight: 600,
//                     fontSize: { xs: "1rem", md: "1.25rem" },
//                     minWidth: "250px !important",
//                     maxWidth: "250px",
//                   }}
//                 >
//                   {clickState === "blog"
//                     ? props.docName || "Untitled Blog"
//                     : props.docName || "Untitled Document"}
//                 </Typography>
//                 {accessToTitle && (
//                   <EditIcon
//                     className="edit-icon"
//                     sx={{
//                       fontSize: "1rem",
//                       color: "white",
//                       opacity: 0,
//                       transition: "opacity 0.2s",
//                     }}
//                   />
//                 )}
//               </Box>
//             )}
//           </Box>

//           {/* Right Section - Status */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               //padding: "15px !important",
//             }}
//           >
//             {props.circularLoader && props.docName && (
//               <StatusChip
//                 icon={<CheckCircleIcon />}
//                 label="Document Saved"
//                 size="small"
//                 sx={{ display: { xs: "none", sm: "flex" } }}
//               />
//             )}
//           </Box>
//         </StyledToolbar>

//         {/* Secondary Toolbar - Menu Options */}
//         {!props.trial && (
//           <Box
//             sx={{
//               borderTop: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
//               px: 2,
//               // py: 1,
//               background: "",
//             }}
//           >
//             <Stack direction="row" spacing={1} alignItems="center">
//               <MenuButton
//                 onClick={(e) => handleMenuClick(e, "file")}
//                 disabled={!accessToFile}
//               >
//                 File
//               </MenuButton>

//               <MenuButton onClick={(e) => handleMenuClick(e, "help")}>
//                 Help
//               </MenuButton>
//             </Stack>

//             {/* File Menu */}
//             <Menu
//               anchorEl={fileMenuAnchor}
//               open={Boolean(fileMenuAnchor)}
//               onClose={handleCloseMenu}
//               PaperProps={{
//                 sx: {
//                   mt: 1,
//                   minWidth: 200,
//                   boxShadow: theme.shadows[8],
//                 },
//               }}
//             >
//               {props.docId
//                 ? renderMenuOptions([
//                     "New Project",
//                     "Open Project",
//                     "Import File",
//                     "Delete",
//                     "Export",
//                     "Print",
//                     "Close Project",
//                   ])
//                 : renderMenuOptions([
//                     "New Project",
//                     "Open Project",
//                     "Import File",
//                     "Delete",
//                     "Print",
//                     "Close Project",
//                   ])}
//             </Menu>

//             {/* Help Menu */}
//             <Menu
//               anchorEl={helpMenuAnchor}
//               open={Boolean(helpMenuAnchor)}
//               onClose={handleCloseMenu}
//               PaperProps={{
//                 sx: {
//                   mt: 1,
//                   minWidth: 200,
//                   boxShadow: theme.shadows[8],
//                 },
//               }}
//             >
//               {renderMenuOptions([
//                 "Tutorials",
//                 "FAQs",
//                 "Feedback",
//                 "What's New",
//               ])}
//             </Menu>
//           </Box>
//         )}

//         {/* Trial Mode Toolbar */}
//         {props.trial && (
//           <Box
//             sx={{
//               borderTop: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
//               px: 2,
//               // py: 1,
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <MenuButton onClick={() => props.grammarCheck()}>
//               Check Grammar
//             </MenuButton>
//           </Box>
//         )}
//       </StyledAppBar>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteConfirmationOpen}
//         onClose={handleCancelDelete}
//         PaperProps={{
//           sx: {
//             borderRadius: 2,
//             minWidth: { xs: "90%", sm: 400 },
//           },
//         }}
//       >
//         <DialogTitle sx={{ pb: 1 }}>
//           <Typography variant="h6" component="div" fontWeight={600}>
//             Confirm Deletion
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete this document? This action cannot be
//             undone.
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCancelDelete} variant="outlined">
//             Cancel
//           </Button>
//           <Button
//             onClick={handleConfirmDelete}
//             variant="contained"
//             color="error"
//             startIcon={<Delete />}
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Download Modal */}
//       <DownloadOptionModal
//         show={isDownloadModalOpen}
//         onHide={closeDownloadModal}
//         id={props.docId}
//       />
//     </>
//   );
// };

// export default CoAuthorTopMenubar;

import React, { useState, useRef, useEffect } from "react";
import {
  Editor,
  EditorState,
  ContentState,
  Modifier,
  SelectionState,
  RichUtils,
} from "draft-js";
import "draft-js/dist/Draft.css";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Popover,
  Box,
  Typography,
  Chip,
  Divider,
  Stack,
  useTheme,
  alpha,
  InputBase,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import FeedbackIcon from "@mui/icons-material/Feedback";
import { Delete } from "@mui/icons-material";

import AddIcon from "@mui/icons-material/Add";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocuments } from "../../services/document";
import { addUserLogs } from "../../services/userLogServices";
import { DownloadOptionModal } from "../MyDocumentsCardsModal";
import { useCheckFeatureAccess } from "../CheckFeature";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { openLeftNavbar } from "../../redux/handleSideNavBarAndModel/handleStatus.action";
import { resetTemplateName } from "../../redux/coauthor/coauthor.action";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// ==================== STYLED COMPONENTS ====================

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.12)",
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: "64px",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    minHeight: "56px",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

const TitleInput = styled(InputBase)(({ theme }) => ({
  color: "white",
  fontSize: "1.25rem",
  fontWeight: 500,
  minWidth: "250px !important",
  maxWidth: "250px",
  backgroundColor: alpha(theme.palette.common.white, 0.12),
  borderRadius: theme.shape.borderRadius,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 2),
    transition: theme.transitions.create(["background-color"]),
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.18),
  },
  "&.Mui-focused": {
    backgroundColor: alpha(theme.palette.common.white, 0.2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

const MenuButton = styled(Button)(({ theme }) => ({
  color: "white",
  textTransform: "none",
  fontSize: "0.95rem",
  fontWeight: 500,
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create(["background-color"]),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
  },
  "&:disabled": {
    color: alpha(theme.palette.common.white, 0.4),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.85rem",
    padding: theme.spacing(0.5, 1),
  },
}));

const StatusChip = styled(Chip)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.white, 0.12),
  color: "white",
  fontWeight: 500,
  borderRadius: theme.shape.borderRadius,
  "& .MuiChip-icon": {
    color: "#4ade80",
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  "& .MuiSvgIcon-root": {
    marginRight: theme.spacing(1.5),
    color: theme.palette.primary.main,
  },
}));

// ==================== MAIN COMPONENT ====================

const CoAuthorTopMenubar = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { clickState } = useSelector((state) => state.handleClick);
  const currentNavItem = useSelector(
    (state) => state.manageCoauthorNavReducer.currentCoauthorNavItem,
  );

  const [fileMenuAnchor, setFileMenuAnchor] = useState(null);
  const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  // const [Finalprojectname, setFinalprojectname] = useState(props.docName);
  const [isEditing, setEditing] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const accessToTitle = useCheckFeatureAccess(currentNavItem, "addTitle");
  const accessToFile = useCheckFeatureAccess(currentNavItem, "file");
  const history = useHistory();

  // useEffect(() => {
  //   console.log("DocNAme_", props.docName, props.editorState);
  //   if (props.docName) {
  //     if (
  //       props.editorState?.trim()?.split(/\s+/).length > 2
  //       // && Finalprojectname === ""
  //     ) {
  //       let proName = props.editorState
  //         ?.trim()
  //         ?.split(/\s+/)
  //         ?.slice(0, 2)
  //         ?.join(" ");
  //       // setFinalprojectname(proName);
  //       props.setDocName(proName);
  //     }
  //   }
  //   //  else if (props.editorState === "" || props.editorState === undefined) {
  //   //     setFinalprojectname(props.docName);
  //   // }
  //   //  else {
  //   //   let proName = props.editorState?.split(/\s+/).slice(0, 2).join(" ");
  //   //   setFinalprojectname(proName);
  //   // }
  // }, [props.editorState]);

  // useEffect(() => {
  //   props.setSharedState(Finalprojectname);
  // }, [Finalprojectname]);

  const handleEditClick = () => {
    if (accessToTitle) {
      setEditing(true);
    }
  };

  const handleSaveClick = () => {
    // setFinalprojectname(Finalprojectname || "Untitled Document");
    setEditing(false);
    props.setUpdateDocName(true)
    props.setDocName(props.docName || "Untitled Document");
  };

  const handleChange = (e) => {
    // setFinalprojectname(e.target.value);
    props.setDocName(e.target.value);
  };

  const handleMenuClick = (event, menuType) => {
    switch (menuType) {
      case "file":
        setFileMenuAnchor(event.currentTarget);
        break;
      case "help":
        setHelpMenuAnchor(event.currentTarget);
        break;
      default:
        break;
    }
  };

  const handleCloseMenu = () => {
    setFileMenuAnchor(null);
    setHelpMenuAnchor(null);
  };

  const handleCloseProject = () => {
    history.goBack();
  };

  const handleOpenProject = () => {
    history.goBack();
  };

  const handleDelete = () => {
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = async () => {
    const res = await deleteDocuments(props.docId || props.newDocId);
    if (res.status === 200) {
      toast.success("Document deleted!");
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "deleteDoc",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
    } else {
      toast.error("Oops..Something went wrong!!");
    }
    setDeleteConfirmationOpen(false);
    history.goBack();
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };

  const handlePrint = () => {
    if (props.editor.current && props.editor.current.editor) {
      const editorContent = props.editor.current.editor.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Document</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              img { max-width: 100%; height: auto; }
              p { margin: 10px 0; }
            </style>
          </head>
          <body>${editorContent}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    }
    handleCloseMenu();
  };

  const handleExport = () => {
    setIsDownloadModalOpen(true);
    handleCloseMenu();
  };

  const closeDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  const handleNewProject = () => {
    handleCloseMenu();
    window.location.reload(true);
  };

  const convertTextToHtml = (text) => {
    const paragraphs = text.split("\n");
    const htmlContent = paragraphs.map((paragraph) => {
      const paragraphWithBreaks = paragraph.replace(/\n{2,}/g, "<br><br>");
      return `<p>${paragraphWithBreaks}</p>`;
    });
    return htmlContent.join("");
  };

  const handleImport = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.style.display = "none";

    fileInput.addEventListener("change", (event) => {
      const fileList = event.target.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileContent = e.target.result;
          const text = fileContent.toString();
          let contentToSend;

          if (file.name.endsWith(".txt")) {
            const htmlContent = convertTextToHtml(text);
            contentToSend = `<br>${htmlContent}`;
            props.setEditorContentUpload(props.editorContent + contentToSend);
          } else if (file.name.endsWith(".docx")) {
            const bodyContentRegex = /<body[^>]*>([\s\S]*?)<\/body>/i;
            const match = bodyContentRegex.exec(text);
            contentToSend = match ? `<br>${match[1]}` : "";
            props.setEditorContentUpload(props.editorContent + contentToSend);
          } else {
            toast.warning("Please upload .txt or .docx file");
            return;
          }
        };
        reader.readAsText(file);
      }
    });

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
    handleCloseMenu();
  };

  const iconMapping = {
    "New Project": <AddIcon />,
    "Open Project": <FolderOpenIcon />,
    "Import File": <ImportExportIcon />,
    Delete: <Delete />,
    Export: <SaveIcon />,
    Print: <PrintIcon />,
    "Close Project": <CloseIcon />,
    Tutorials: <EmojiObjectsIcon />,
    FAQs: <HelpOutlineIcon />,
    Feedback: <FeedbackIcon />,
    "What's New": <NewReleasesIcon />,
  };

  const actionHandlers = {
    "Close Project": handleCloseProject,
    Print: handlePrint,
    Export: handleExport,
    Delete: handleDelete,
    "New Project": handleNewProject,
    "Open Project": handleOpenProject,
    "Import File": handleImport,
  };

  const renderMenuOptions = (options) => {
    return options.map((option) => (
      <StyledMenuItem key={option} onClick={() => actionHandlers[option]?.()}>
        {iconMapping[option]}
        <Typography variant="body2">{option}</Typography>
      </StyledMenuItem>
    ));
  };

  const handleBackButton = () => {
    if (props.isCoAuthor) {
      history.push("/coauthor");
    } else {
      history.goBack();
    }
    dispatch(resetTemplateName(""));
    dispatch(openLeftNavbar());
    // handleMenuItemClick("Editor View");
  };

  return (
    <>
      <StyledAppBar position="static" elevation={0}>
        {/* Main Toolbar */}
        <StyledToolbar
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          {!props.isGrammarCheck && !props.trial && !props.mobileView && (
            <LightTooltip title="Back">
              <KeyboardBackspaceIcon
                onClick={handleBackButton}
                color="white"
                style={{ cursor: "pointer" }}
              />
            </LightTooltip>
          )}
          {/* linear-gradient(135deg, rgba(31, 20, 128, 1), rgb(12, 127, 243)) */}

          {/* Left Section - Title */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              padding: "15px !important",
            }}
          >
            {isEditing ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TitleInput
                  value={props.docName}
                  onChange={handleChange}
                  autoFocus
                  placeholder="Document title"
                />

                <IconButton
                  size="small"
                  onClick={handleSaveClick}
                  sx={{
                    color: "white",
                    bgcolor: alpha(theme.palette.common.white, 0.1),
                    "&:hover": {
                      bgcolor: alpha(theme.palette.common.white, 0.2),
                    },
                  }}
                >
                  <CheckCircleIcon fontSize="small" />
                </IconButton>
              </Box>
            ) : (
              <Box
                onClick={handleEditClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: accessToTitle ? "pointer" : "default",
                  gap: 1,
                  backgroundColor: alpha(theme.palette.common.white, 0.12),
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  transition: "background-color 0.2s",
                  "&:hover": accessToTitle
                    ? {
                        backgroundColor: alpha(
                          theme.palette.common.white,
                          0.18,
                        ),
                        "& .edit-icon": { opacity: 1 },
                      }
                    : {},
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: "1rem", md: "1.25rem" },
                    minWidth: "250px !important",
                    maxWidth: "250px",
                  }}
                >
                  {clickState === "blog"
                    ? props.docName || "Untitled Blog"
                    : props.docName || "Untitled Document"}
                </Typography>
                {accessToTitle && (
                  <EditIcon
                    className="edit-icon"
                    sx={{
                      fontSize: "1rem",
                      color: "white",
                      opacity: 0,
                      transition: "opacity 0.2s",
                    }}
                  />
                )}
              </Box>
            )}
          </Box>

          {/* Right Section - Status */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "15px !important",
            }}
          >
            {props.circularLoader && props.docName && (
              <StatusChip
                icon={<CheckCircleIcon />}
                label="Document Saved"
                size="small"
                sx={{ display: { xs: "none", sm: "flex" } }}
              />
            )}
          </Box>
        </StyledToolbar>

        {/* Secondary Toolbar - Menu Options */}
        {/* {!props.trial && (
          <Box
            sx={{
              borderTop: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
              px: 2,
              py: 1,
              background: "",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <MenuButton
                onClick={(e) => handleMenuClick(e, "file")}
                disabled={!accessToFile}
              >
                File
              </MenuButton>

              <MenuButton onClick={(e) => handleMenuClick(e, "help")}>
                Help
              </MenuButton>
            </Stack>

            <Menu
              anchorEl={fileMenuAnchor}
              open={Boolean(fileMenuAnchor)}
              onClose={handleCloseMenu}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: theme.shadows[8],
                },
              }}
            >
              {props.docId
                ? renderMenuOptions([
                    "New Project",
                    "Open Project",
                    "Import File",
                    "Delete",
                    "Export",
                    "Print",
                    "Close Project",
                  ])
                : renderMenuOptions([
                    "New Project",
                    "Open Project",
                    "Import File",
                    "Delete",
                    "Print",
                    "Close Project",
                  ])}
            </Menu>

            <Menu
              anchorEl={helpMenuAnchor}
              open={Boolean(helpMenuAnchor)}
              onClose={handleCloseMenu}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: theme.shadows[8],
                },
              }}
            >
              {renderMenuOptions([
                "Tutorials",
                "FAQs",
                "Feedback",
                "What's New",
              ])}
            </Menu>
          </Box>
        )} */}

        {/* Trial Mode Toolbar */}
        {props.trial && (
          <Box
            sx={{
              borderTop: `1px solid ${alpha(theme.palette.common.white, 0.1)}`,
              px: 2,
              py: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MenuButton onClick={() => props.grammarCheck()}>
              Check Grammar
            </MenuButton>
          </Box>
        )}
      </StyledAppBar>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCancelDelete}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: { xs: "90%", sm: 400 },
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" component="div" fontWeight={600}>
            Confirm Deletion
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this document? This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCancelDelete} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            startIcon={<Delete />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Download Modal */}
      <DownloadOptionModal
        show={isDownloadModalOpen}
        onHide={closeDownloadModal}
        id={props.docId}
      />
    </>
  );
};

export default CoAuthorTopMenubar;
